"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Textarea = /** @class */function (_super) {
  __extends(Textarea, _super);
  function Textarea() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      hasFocus: false,
      value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue || ''
    };
    _this.onTextAreaMounted = function (textArea) {
      _this._textArea = textArea;
      if (!textArea) {
        return;
      }
      if (_this.props.autoFocus) {
        textArea.focus();
      }
      if (_this.props.autoFocus === 'selectAll') {
        try {
          textArea.setSelectionRange(0, textArea.value.length);
        } catch (ex) {
          // ignore
        }
      }
    };
    _this.getValue = function () {
      return _this.state.value;
    };
    _this.hasFocus = function () {
      return _this.state.hasFocus;
    };
    _this.handleChange = function (event) {
      _this.setState({
        value: event.target.value
      }, function () {
        if (this.props.onChange) {
          this.props.onChange(this.state.value);
        }
      });
    };
    _this.handleBlur = function (event) {
      _this.setState({
        hasFocus: false
      }, function () {
        if (this.props.onBlur) {
          this.props.onBlur(event);
        }
      });
    };
    _this.handleFocus = function (event) {
      _this.setState({
        hasFocus: true
      }, function () {
        if (this.props.onFocus) {
          this.props.onFocus(event);
        }
      });
    };
    return _this;
  }
  Textarea.prototype.componentWillReceiveProps = function (nextProps) {
    this.setState({
      value: nextProps.value !== undefined ? nextProps.value : this.props.defaultValue || ''
    });
  };
  Textarea.prototype.render = function () {
    var _a;
    var textareaClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('textarea')] = true, _a[vdl_prefix_1.vdlPrefix('textarea--disabled')] = this.props.disabled, _a[vdl_prefix_1.vdlPrefix('textarea--required')] = this.props.required, _a);
    var _b = this.props,
      id = _b.id,
      ariaInvalid = _b.ariaInvalid,
      ariaRequired = _b.ariaRequired,
      className = _b.className,
      disabled = _b.disabled,
      defaultValue = _b.defaultValue;
    var customProps = _1.omit(this.props, Object.keys(Textarea.propTypes));
    return react_1.default.createElement("textarea", __assign({}, customProps, {
      "aria-invalid": ariaInvalid,
      "aria-required": ariaRequired,
      className: classnames_1.classNames(className, textareaClasses),
      defaultValue: defaultValue,
      disabled: disabled,
      id: id,
      onChange: this.handleChange,
      onKeyUp: this.props.onKeyUp,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      placeholder: this.props.placeholder,
      readOnly: this.props.readOnly,
      ref: this.onTextAreaMounted,
      value: this.state.value
    }));
  };
  Textarea.propTypes = {
    ariaInvalid: prop_types_1.default.bool,
    ariaRequired: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.oneOf([true, false, 'selectAll']),
    className: prop_types_1.default.string,
    defaultValue: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    id: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    onKeyUp: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    value: prop_types_1.default.string
  };
  Textarea.defaultProps = {
    autoFocus: false
  };
  return Textarea;
}(react_1.default.PureComponent);
exports.Textarea = Textarea;